/**
 * Dispatches a custom event with the specified name and details.
 * @template T
 * @param eventName - The name of the custom event to dispatch.
 * @param payload - The details to attach to the custom event.
 */
export function sendCustomEvent(eventName, payload) {
    if (typeof document === 'undefined') {
        return;
    }
    const event = new CustomEvent(eventName, {
        detail: payload,
    });
    document.dispatchEvent(event);
}
